import React from "react";

import { SearchInput } from "../../../../components/Input";
import {
  Toolbar,
  ToolbarCount,
  ToolbarField,
  ToolbarSearch,
  ToolbarSelect,
} from "../../styles";
import { ASSET_TYPE_OPTIONS, PRICE_OPTIONS } from "../constants";
import {
  AssetTypeFilter,
  InstrumentsToolbarProps,
  PriceFilter,
} from "../types";

export const InstrumentsToolbar: React.FC<InstrumentsToolbarProps> = ({
  filters: { query, assetType, price },
  countLabel,
  onChange,
}) => {
  const handleSearch = (event: React.ChangeEvent<HTMLInputElement>) =>
    onChange({ query: event.target.value });
  const handleClearSearch = () => onChange({ query: "" });
  const handleAssetType = (event: React.ChangeEvent<HTMLSelectElement>) =>
    onChange({ assetType: event.target.value as AssetTypeFilter });
  const handlePrice = (event: React.ChangeEvent<HTMLSelectElement>) =>
    onChange({ price: event.target.value as PriceFilter });

  return (
    <Toolbar>
      <ToolbarSearch>
        <SearchInput
          aria-label="Search instruments"
          placeholder="Search symbol, name, exchange or Yahoo symbol"
          value={query}
          onChange={handleSearch}
          onClear={handleClearSearch}
        />
      </ToolbarSearch>
      <ToolbarField>
        Asset type
        <ToolbarSelect value={assetType} onChange={handleAssetType}>
          {ASSET_TYPE_OPTIONS.map(({ value, label }) => (
            <option key={value} value={value}>
              {label}
            </option>
          ))}
        </ToolbarSelect>
      </ToolbarField>
      <ToolbarField>
        Price
        <ToolbarSelect value={price} onChange={handlePrice}>
          {PRICE_OPTIONS.map(({ value, label }) => (
            <option key={value} value={value}>
              {label}
            </option>
          ))}
        </ToolbarSelect>
      </ToolbarField>
      {countLabel && <ToolbarCount role="status">{countLabel}</ToolbarCount>}
    </Toolbar>
  );
};
